<div class="perm-action" [class.perm-action--on]="checked()">
  <app-switch
    class="perm-action__switch"
    [checked]="checked()"
    [ariaLabel]="action().label"
    (sendChecked)="checkedChange.emit($event)"></app-switch>
  <!-- Clicar no texto também liga/desliga, como numa linha de configuração comum. -->
  <div class="perm-action__text" (click)="checkedChange.emit(!checked())">
    <p class="perm-action__label">
      <span>
        @for (part of labelParts(); track $index) {
          <span [class.perm-action__mark]="part.match">{{ part.text }}</span>
        }
      </span>
      @if (showKind()) {
        <span
          class="perm-action__tag"
          [class.perm-action__tag--write]="action().kind === 'write'"
          [class.perm-action__tag--menu]="action().kind === 'menu'"
          >{{ kindLabel() }}</span
        >
      }
      @if (changed()) {
        <span class="perm-action__tag perm-action__tag--changed">não salvo</span>
      }
    </p>
    @if (hintText()) {
      <p class="perm-action__hint">{{ hintText() }}</p>
    }
  </div>
  <!-- O código técnico só no (i), que aparece ao passar o mouse ou focar a linha. -->
  <span
    class="perm-action__info"
    tabindex="0"
    role="note"
    [pTooltip]="codeTooltip()"
    tooltipPosition="left"
    [attr.aria-label]="codeTooltip()"
    ><i class="pi pi-info-circle" aria-hidden="true"></i
  ></span>
</div>
